import React from 'react';
import { Store } from 'lucide-react';

const CollectionCollage = ({ images = [], fallbackImage, name }) => {
    // If we have no images, use cover image or placeholder
    if (!images || images.length === 0) {
        if (fallbackImage) {
            return (
                <img
                    src={fallbackImage}
                    alt={name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
            );
        }
        return (
            <div className="w-full h-full flex items-center justify-center bg-slate-200 text-slate-400">
                <Store size={48} />
            </div>
        );
    }

    // Determine grid layout based on number of available images
    // Limit to max 12 images
    const count = Math.min(images.length, 12);
    const displayImages = images.slice(0, count);

    let gridClass = 'grid-cols-1 grid-rows-1';
    let largeIndex = -1;
    let largeClass = 'col-span-2 row-span-2';

    if (count >= 12) {
        gridClass = 'grid-cols-4 grid-rows-3';
    } else if (count >= 9) {
        gridClass = 'grid-cols-4 grid-rows-3';
        largeIndex = 0;
    } else if (count >= 5) {
        gridClass = 'grid-cols-4 grid-rows-2';
        largeIndex = 0;
    } else if (count >= 4) {
        gridClass = 'grid-cols-2 grid-rows-2';
    } else if (count === 3) {
        gridClass = 'grid-cols-2 grid-rows-2';
        largeIndex = 0;
        largeClass = 'col-span-2 row-span-1';
    } else if (count === 2) {
        gridClass = 'grid-cols-2 grid-rows-1';
    }

    return (
        <div className={`w-full h-full grid gap-0.5 bg-white ${gridClass} group-hover:scale-105 transition-transform duration-700`}>
            {displayImages.map((src, i) => {
                const isLarge = i === largeIndex;
                return (
                    <div key={i} className={`relative overflow-hidden bg-slate-100 ${isLarge ? largeClass : ''}`}>
                        <img
                            src={src || fallbackImage}
                            alt={`${name} item ${i + 1}`}
                            className="w-full h-full object-cover"
                            onError={(e) => {
                                e.target.onerror = null;
                                if (fallbackImage) e.target.src = fallbackImage;
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default CollectionCollage;
